import useResponsive from "@/hooks/use-responsive"

import { LockHomeComplexBreadcrumbApplication } from "../navigation/components/complex-breadcrumb-applications/lock-home-complex-breadcrumb-application"
import { LockPagesComplexBreadcrumbApplication } from "../navigation/components/complex-breadcrumb-applications/lock-pages-complex-breadcrumb-application"
import { LockSubItem } from "../navigation/subitems/lock-subitem"

const LOCK_BREADCRUMB_ITEMS = [new LockSubItem(), LockHomeComplexBreadcrumbApplication]

export const LOCK_PAGE_MOBILE_SWITCH_WIDTH = 360

const MOBILE_BREADCRUMB_ITEMS = [
  new LockSubItem(),
  // LockHomeComplexBreadcrumbApplication,
  LockPagesComplexBreadcrumbApplication,
]

export const makeBreadcrumbs = () => {
  const { width } = useResponsive()
  return width < LOCK_PAGE_MOBILE_SWITCH_WIDTH ? MOBILE_BREADCRUMB_ITEMS : LOCK_BREADCRUMB_ITEMS
}
